export default __webpack_public_path__ + "static/media/action-button-in-appbar.9a4eb14b.png";